import { Outlet } from "react-router-dom";

function DepartmentLayout() {
  return <Outlet />;
}

export default DepartmentLayout;
